export default __webpack_public_path__ + "static/media/permission_denied.edc37990.svg";